import { useMotionValue } from 'framer-motion';
import React, { useCallback, useMemo, useState } from 'react';
import Sequence from '../../components/sequence';
import { SeqencePlaceholder } from '../../components/sequence/Placeholder';
import Visibility from '../../components/Visibility';
import { AppContext } from '../../Context';
import { buildImageURL, getSeqFrames, getTrack, pureTrans } from '../../helpers';
import './style.scss';
import { Description, Image, renderLineBreak, SubTitle } from '../../components/layouts';


const isWebp = document.querySelector('html').classList.contains('webpSupport');

const IMG_LENS = isWebp ? buildImageURL('/camera-origin.webp') : buildImageURL('/camera-origin.png');
const IMG_DESKTOP = isWebp ? buildImageURL('/camera-origin-desktop.webp') : buildImageURL('/camera-origin-desktop.png');

const track = getTrack({ block: 28 });

export function CameraCloseUp({mobile = false}) {

  const [progress, setProgress] = useState(0);

  const { scale, x, y, opacity } = useMemo(() => {
    return {
      scale: pureTrans(progress, [-0.03, 0.45], [1.5, 0.08], 3),
      x: pureTrans(progress, [-0.03, 0.45], [0, 56], 3),
      y: pureTrans(progress, [-0.03, 0.45], [260, -144], 3),
      opacity: pureTrans(progress, [-0.03, 0.25, 0.45], [0, 0.1, 1], 3),
    };
  }, [progress]);

  const handleUpdate = useCallback(
    (e, { calculations: { percentagePassed } }) => {
      setProgress(percentagePassed);
    },
    [setProgress]
  );

  // console.log('scale', scale, 'x', x*2, 'y', y*2);

  return (
    <Visibility fireOnMount offset={[-1000, 1000]} onUpdate={handleUpdate} className="page-section section-camera_close_up inverted" data-track={track}>
      <div className="sticky-content center">
        <div className="section-content">
          <SubTitle>
            <span>
              相机 Mix
            </span>
            <br/>
            高光时刻{renderLineBreak(mobile)}随时就位
          </SubTitle>
          <Description>
            创造性的将每一颗镜头和拍摄模式以可见和随意组合的方<br/>式装进你的口袋。
          </Description>
          <div className="desktop-box">
            <Image className="img-desktop" src={IMG_DESKTOP} style={{opacity: `${opacity}`}} />
            <Image className="img-lens" src={IMG_LENS} style={{transform: `translate3d(${mobile ? x : x*2}px, ${mobile ? y : y*2}px, 0) scale(${scale})`}} />
          </div>
        </div>
      </div>
    </Visibility>
  );
}
